import React from 'react'
import classNames from 'classnames'
import { pure } from 'recompose'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import Toolbar from 'material-ui-next/Toolbar'
import Select from 'material-ui-next/Select'
import { MenuItem } from 'material-ui-next/Menu'
import withStyles from 'material-ui-next/styles/withStyles'
import breakpoints from '../../styles/breakpoints'

import {
  getWorlds,
  getWorld,
  makeGetCategoriesByWorld,
  getCategory,
} from '../../selectors'

const styles = theme => ({
  white: {
    color: 'white!important',
  },
  toolbarGroup: {
    display: 'inline-flex',
    height: '100%',
    alignItems: 'center',
  },
  selectRoot: {
    color: theme.swapick.colors.positive,
    textTransform: 'uppercase',
    paddingTop: 3,
    fontSize: 14,
    marginRight: 15,
    height: '32px',
    letterSpacing: 0.8,
  },
  bigger: {
    fontSize: 14,
  },
  select: {
    backgroundColor: 'transparent',
    '&:focus': {
      backgroundColor: 'transparent',
    },
  },
  selectIcon: {
    color: theme.swapick.colors.positive,
    [`@media (max-width: ${breakpoints.xs})`]: {
      top: 2,
    },
  },
  menuItem: {
    ...theme.swapick.styles.dropdown.menuItem,
  },
  selectedMenuItem: {
    color: `${theme.swapick.colors.secondary}!important`,
  },
  [`@media (max-width: ${breakpoints.xs})`]: {
    selectRoot: {
      fontWeight: 500,
      letterSpacing: '0.8px',
      fontSize: 9,
    },
    // Mobile title font
    bigger: {
      fontSize: 10,
    },
    menuItem: {
      fontSize: 10,
    },
  },
})

const WorldsAndCategoriesDropdowns = ({
  classes,
  worlds,
  world,
  worldCategories,
  category,
  showAllWorlds = true,
  showAllCategories = true,
  hideWorlds = false,
  hideCategories = false,
  white = false,
  biggerFontOnMobile = false,
  makeLinkTo,
}) => (
  <div className={classes.toolbarGroup}>
    {worlds &&
      !hideWorlds &&
      (world || showAllWorlds) &&
      <Select
        disableUnderline
        value={world ? world.id : 'all'}
        classes={{
          root: classNames(classes.selectRoot, {
            [classes.white]: white,
            [classes.bigger]: biggerFontOnMobile,
          }),
          icon: classNames(classes.selectIcon, { [classes.white]: white }),
          select: classes.select,
        }}>
        {showAllWorlds &&
          <MenuItem
            classes={{
              root: classes.menuItem,
              selected: classes.selectedMenuItem,
            }}
            component={Link}
            to={makeLinkTo({})}
            value={'all'}>
            Tutti i mondi
          </MenuItem>}

        {worlds.map(world => (
          <MenuItem
            component={Link}
            classes={{
              root: classes.menuItem,
              selected: classes.selectedMenuItem,
            }}
            to={makeLinkTo({ world })}
            key={world.id}
            value={world.id}>
            {world.nome}
          </MenuItem>
        ))}
      </Select>}

    {world &&
      !hideCategories &&
      worldCategories &&
      (category || showAllCategories) &&
      <Select
        disableUnderline
        value={category ? category.id : 'all'}
        classes={{
          root: classNames(classes.selectRoot, {
            [classes.white]: white,
            [classes.bigger]: biggerFontOnMobile,
          }),
          icon: classNames(classes.selectIcon, { [classes.white]: white }),
          select: classes.select,
        }}>
        {showAllCategories &&
          <MenuItem
            classes={{
              root: classes.menuItem,
              selected: classes.selectedMenuItem,
            }}
            component={Link}
            to={makeLinkTo({ world })}
            value={'all'}
            selected>
            Tutte le categorie
          </MenuItem>}

        {worldCategories.map(category => (
          <MenuItem
            classes={{
              root: classes.menuItem,
              selected: classes.selectedMenuItem,
            }}
            component={Link}
            to={makeLinkTo({ world, category })}
            key={category.id}
            value={category.id}>
            {category.nome}
          </MenuItem>
        ))}
      </Select>}
  </div>
)

const mapStateToProps = (state, ownProps) => {
  const worlds = getWorlds(state)

  let world
  let category
  let worldCategories

  // Lookup world and worldCategories unsing world slug
  if (typeof ownProps.worldSlug !== 'undefined') {
    world = getWorld(state, ownProps.worldSlug)
    const getCategories = makeGetCategoriesByWorld(ownProps.worldSlug)
    worldCategories = getCategories(state)
  }

  if (typeof ownProps.categorySlug !== 'undefined') {
    category = getCategory(state, ownProps.categorySlug)
    if (category && !world) {
      world = getWorld(state, category.mondo)
      const getCategories = makeGetCategoriesByWorld(category.mondo)
      worldCategories = getCategories(state)
    }
  }

  return {
    worlds,
    world,
    worldCategories,
    category,
  }
}

export default withStyles(styles)(
  connect(mapStateToProps)(pure(WorldsAndCategoriesDropdowns))
)



// WEBPACK FOOTER //
// ./src/common/TopBar/WorldsAndCategoriesDropdowns.js